{
  "toast": {
    "region": "Notifications d’alerte",
    "reason": {
      "opened": "Nouvelle alerte",
      "fired": "Nouveau déclenchement (×{{count}})",
      "unsnoozed": "Rappel : veille terminée"
    },
    "announce": "{{reason}} : {{title}}",
    "ack": "Prendre en compte",
    "view": "Voir",
    "close": "Fermer la notification « {{title}} »",
    "ackFailed": "La prise en compte a échoué.",
    "nativeBody": "{{reason}} · {{rule}}"
  },
  "settings": {
    "title": "Notifications",
    "description": "Chaque règle choisit ses canaux ; ces réglages valent pour toutes les règles.",
    "loading": "Lecture des réglages de notification…",
    "error": "Impossible de lire les réglages de notification. Ils réapparaîtront dès que le serveur répondra.",
    "quiet": {
      "title": "Heures calmes",
      "description": "Pendant ces heures, le bureau et Telegram se taisent. Les alertes restent visibles dans l’app, et une règle critique peut passer outre.",
      "enabled": "Activer les heures calmes",
      "start": "Début",
      "end": "Fin",
      "timezone": "Fuseau horaire",
      "timezoneHint": "Nom IANA, par exemple Europe/Paris.",
      "window": "De {{start}} à {{end}}.",
      "windowOvernight": "De {{start}} à {{end}} le lendemain.",
      "invalidTime": "Indiquez une heure au format HH:MM.",
      "invalidTimezone": "Fuseau horaire inconnu. Utilisez un nom comme Europe/Paris."
    },
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Réglages enregistrés.",
    "saveFailed": "Enregistrement impossible. Vérifiez les champs et réessayez.",
    "telegram": {
      "title": "Telegram",
      "configured": "Configuré",
      "notConfigured": "Non configuré sur le serveur",
      "notConfiguredHint": "Ajoutez TELEGRAM_BOT_TOKEN et TELEGRAM_CHAT_ID à l’environnement de l’API, puis redémarrez-la.",
      "test": "Envoyer un message de test",
      "testing": "Envoi…",
      "testSent": "Message de test envoyé. Vérifiez Telegram.",
      "testNotConfigured": "Telegram n’est pas configuré sur le serveur.",
      "testRejected": "Telegram a refusé le message. Vérifiez le jeton du bot et l’identifiant de conversation.",
      "testFailed": "L’envoi a échoué. Réessayez dans un instant."
    },
    "native": {
      "title": "Notifications du système",
      "description": "Utilisées par les règles qui ont le canal Bureau.",
      "loading": "Lecture de l’autorisation…",
      "granted": "Autorisées",
      "denied": "Bloquées",
      "deniedHint": "Changez l’autorisation dans les réglages du navigateur ou du système, puis rechargez la page.",
      "default": "Pas encore autorisées",
      "request": "Autoriser les notifications",
      "requesting": "Demande en cours…",
      "unsupported": "Ce navigateur ne propose pas de notifications du système : les alertes restent visibles dans l’app.",
      "error": "Impossible de lire ou de demander l’autorisation."
    }
  }
}
